module.exports = __webpack_public_path__ + "static/AngelaHe6-281ecc5e1d710f4f07c7a4fce80fc6f8.webp";